import { useState } from "react";

const COLORS = [
  { name: "Gray", hex: "#7A7A7A" },
  { name: "Orange", hex: "#E88A2B" },
  { name: "Ivory", hex: "#FBF6E7" },
  { name: "Gold", hex: "#C9A961" },
  { name: "Yellow", hex: "#F4E017" },
  { name: "Brown", hex: "#7A4A18" },
  { name: "Black", hex: "#0E0E0E" },
  { name: "Purple", hex: "#8B2FA0" },
  { name: "White", hex: "#FFFFFF" },
];

export default function ColorPicker({ defaultColor = "Gold" }) {
  const [selected, setSelected] = useState(defaultColor);

  return (
    <div data-testid="color-picker-section" className="mt-8">
      <div className="flex items-baseline justify-between">
        <div className="overline">Exterior Finish</div>
        <div className="text-xs text-[#5C5C5C]" data-testid="color-picker-selected-name">
          {selected}
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-2.5">
        {COLORS.map((c) => {
          const isSelected = c.name === selected;
          return (
            <button
              key={c.name}
              type="button"
              data-testid={`color-swatch-${c.name.toLowerCase()}`}
              onClick={() => setSelected(c.name)}
              aria-label={`Select ${c.name}`}
              aria-pressed={isSelected}
              title={c.name}
              className={`h-9 w-9 rounded-full transition-all duration-300 focus:outline-none ${
                isSelected
                  ? "ring-2 ring-offset-2 ring-offset-white ring-[#1C1C1C] scale-110"
                  : "ring-1 ring-[#E5E5E5] hover:ring-[#A8A096] hover:scale-105"
              }`}
              style={{ backgroundColor: c.hex }}
            />
          );
        })}
      </div>
      <p className="mt-3 text-[11px] text-[#A8A096]">
        Colours may vary slightly on screen. Final samples provided during concierge consultation.
      </p>
    </div>
  );
}
